<template>
  <div id="team">
    <!-- TITLE & BACK LINK: FOR NAME, POSITION + CONTACT -->
    <PageTitleDesktop class="d-none d-md-block" :title="entry.title" :position="entry.position" :kontakt="entry.kontakt"></PageTitleDesktop>
    <PageTitleMobile class="d-block d-md-none" :title="entry.title" :position="entry.position" :kontakt="entry.kontakt"></PageTitleMobile>
    <!-- CONTENT -->
    <b-container fluid>
      <b-row>
        <b-col cols="12" offset="0" md="8" offset-md="4">

          <!-- TEAMBILD -->
          <b-row v-if="entry.teamBild != undefined && entry.teamBild.length" no-gutters id="teambild">
            <b-col cols="6" md="6" lg="3">
                <div><img class="team-bild" :src="entry.teamBild[0].url" :alt="entry.teamBild[0].title"></div>
            </b-col>
          </b-row>

          <!-- LOOP FOR MATRIX PERSÖNLICHE INHALTE -->
          <div v-for="(item, i) in entry.persoenlicheInhalte" :key="i">

            <!-- ZWEI SPALTEN -->
            <div class="space-ba-sm" v-if="item.__typename == 'persoenlicheInhalte_zweiSpalten_BlockType'">
              <h3 class="space-ba-xs" v-if="item.titel">{{item.titel}}</h3>
              <b-row no-gutters class="spalten border-b" :class="{'border-t': j == 0}" v-for="(spalte, j) in item.inhaltSupertable" :key="j">
                <b-col class="type-xs" cols="12" md="4">
                  <div class="a-underline" v-html="newLineText(spalte.linkeSpalte)"></div>
                </b-col>
                <b-col class="type-xs" cols="12" md="8">
                  <div class="a-underline" v-html="newLineText(spalte.rechteSpalte)"></div>
                </b-col>
              </b-row>
            </div>

            <!-- EINE SPALTEN -->
            <div class="space-ba-sm" v-if="item.__typename == 'persoenlicheInhalte_eineSpalte_BlockType'">
              <h3 class="space-ba-xs" v-if="item.titel">{{item.titel}}</h3>
              <div 
                class="spalten border-b type-xs a-underline" 
                :class="{'border-t': j == 0}" 
                v-for="(spalte, j) in item.inhaltSupertableEineSpalte" 
                :key="j"
                v-html="newLineText(spalte.spalte)">
              </div>
            </div>

            <!-- TABLE LIST -->
            <div class="space-ba-sm" v-if="item.__typename == 'persoenlicheInhalte_liste_BlockType'">
              <h3 v-if="item.titel" class="space-ba-xs">{{item.titel}}</h3>
              <ul>
                <li class="type-xs a-underline" v-for="(table, j) in item.table" :key="j" v-html="newLineText(table.inhalt)"></li>
              </ul>
            </div>

          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PageTitleDesktop from "@/components/Shared/PageTitleDesktop";
import PageTitleMobile from "@/components/Shared/PageTitleMobile";

let axios = require("axios");

export default {
  name: "TeamEntry",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Basel Academy Team",
    // all titles will be injected into this template
    description: "Die Basel Academy ist ein wissenschaftliches Institut und Dienstleister in den Bereichen Qualitätsmessung, Versorgungsforschung und klinische Forschung.",
  }),
  components: {
    PageTitleDesktop,
    PageTitleMobile
  },
  data() {
    return {
      entrySlug: this.$route.params.slug,
      entry: [],
    };
  },
  created () {
    axios({
      url: "https://backend.basel-academy.ch/api",
      method: "POST",
      data: {
        query: `
          query {
            team:entries(section: "team", slug: "` + this.entrySlug +`", site: "${this.$i18n.locale}") {
              title
              ... on team_team_Entry {
                position
                kontakt
                teamBild @transform(width: 600, quality: 70, immediately: true, format: "jpg") {
                  url
                  title
                  width
                  height
                }
                persoenlicheInhalte {
                  ... on persoenlicheInhalte_zweiSpalten_BlockType {
                    __typename
                    titel
                    inhaltSupertable {
                      ... on inhaltSupertable_BlockType {
                        linkeSpalte
                        rechteSpalte
                      }
                    }
                  }
                  ... on persoenlicheInhalte_eineSpalte_BlockType {
                    __typename
                    titel
                    inhaltSupertableEineSpalte {
                      ... on inhaltSupertableEineSpalte_BlockType {
                        spalte
                      }
                    }
                  }
                  ... on persoenlicheInhalte_liste_BlockType {
                    __typename
                    titel
                    ... on persoenlicheInhalte_liste_BlockType {
                      table {
                        inhalt
                      }
                    }
                  }
                }
              }
            }
          }`
      }
    }).then((result) => {
      let data = result.data.data.team[0];
      this.entry = data;
    });
  },
  methods: {
    newLineText(el) {
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-fluid {
  padding-top: 0rem;
}
@media (min-width: 768px) {
  .container-fluid {
    padding-top: 2rem;
  }
}

#teambild {
  padding-bottom: 2rem;
}

.spalten {
  padding-top: 1.6rem;
  padding-bottom: 1.5rem;
}
</style>